var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
export var Divider = styled.hr(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border: none;\n  border-top: 1px solid ", ";\n  margin: 0;\n\n  &.margin {\n    margin: 27px 0;\n  }\n"], ["\n  border: none;\n  border-top: 1px solid ", ";\n  margin: 0;\n\n  &.margin {\n    margin: 27px 0;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.separator.color;
});
var templateObject_1;
//# sourceMappingURL=Divider.js.map